const comments = [
  {
    name: '格斗漫画迷',
    date: '2026.07.25',
    content: '追了刃牙十年了，这个平台把全系列都收齐了，死刑犯篇是我心中永远的经典。刃牙漫画完整版一次性看个够太过瘾了！下拉式阅读体验也很流畅。',
    avatar: 'https://readdy.ai/api/search-image?query=Manga%20fan%20avatar%20circle%20portrait%20style%2C%20abstract%20geometric%20face%20with%20warm%20tones%2C%20minimal%20design%2C%20crimson%20and%20amber%20color%20scheme%2C%20clean%20background&width=80&height=80&seq=avatar-baki-1&orientation=squarish',
  },
  {
    name: '地下斗技场常客',
    date: '2026.07.22',
    content: '刃牙漫画大全从第一部到最新全都有，终于不用到处找了。每一话的画功都值得细品，尤其父子决战那一段，每次看都热血沸腾。',
    avatar: 'https://readdy.ai/api/search-image?query=Manga%20fan%20avatar%20circle%20portrait%20style%2C%20abstract%20geometric%20face%20with%20dark%20tones%2C%20minimal%20design%2C%20warm%20amber%20color%20scheme%2C%20clean%20background&width=80&height=80&seq=avatar-baki-2&orientation=squarish',
  },
  {
    name: '武藏粉丝团',
    date: '2026.07.20',
    content: '刃牙道武藏篇真的太精彩了！古流剑术在现代的重新诠释，每次宫本武藏出场都能感受到那种压迫感。刃牙漫画在线看方便多了。',
    avatar: 'https://readdy.ai/api/search-image?query=Manga%20fan%20avatar%20circle%20portrait%20style%2C%20abstract%20geometric%20face%20with%20crimson%20tones%2C%20minimal%20design%2C%20warm%20color%20scheme%2C%20clean%20background&width=80&height=80&seq=avatar-baki-3&orientation=squarish',
  },
  {
    name: '相扑道新人',
    date: '2026.07.18',
    content: '从相扑道篇入坑的，没想到回过头补前面的内容越看越上头。刃牙漫画合集太全了，一口气从第一部看到了最新话。强烈推荐！',
    avatar: 'https://readdy.ai/api/search-image?query=Manga%20fan%20avatar%20circle%20portrait%20style%2C%20abstract%20geometric%20face%20with%20gold%20tones%2C%20minimal%20design%2C%20warm%20color%20scheme%2C%20clean%20background&width=80&height=80&seq=avatar-baki-4&orientation=squarish',
  },
  {
    name: '老读者十年',
    date: '2026.07.15',
    content: '从大学追到现在，刃牙陪伴了我整个青春。这个平台收录得很全，外传系列也有。下拉式设计比翻页舒服太多了，刃牙漫画免费全集良心。',
    avatar: 'https://readdy.ai/api/search-image?query=Manga%20fan%20avatar%20circle%20portrait%20style%2C%20abstract%20geometric%20face%20with%20warm%20red%20tones%2C%20minimal%20design%2C%20clean%20background&width=80&height=80&seq=avatar-baki-5&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          读者评论
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          听听刃牙漫画的读者们怎么说
        </p>
        <div className="max-w-3xl mx-auto space-y-4">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="font-heading text-sm font-bold text-foreground-900">{item.name}</div>
                  <div className="text-[11px] text-foreground-500">{item.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}